export const CLEAR_APP_STATE = 'CLEAR_APP_STATE/LOGOUT/@WISELY/WEB';

export const clearAppState = () => ({
	type: CLEAR_APP_STATE,
});



// WEBPACK FOOTER //
// ./src/redux/logout/logout.action.js